import React from "react";
import Helmet from "react-helmet";

import Footer from "../components/common/footer.jsx";
import CTASection from "../components/sections/CTASection";
import HeroSection from "../components/sections/HeroSection";
import PhilosophySection from "../components/sections/PhilosophySection";
import ProjectsSection from "../components/sections/ProjectsSection";
import StorySection from "../components/sections/StorySection";
import SEO from "../data/seo";

import "./styles/homepage.css";

const SITE_URL = "https://azerty-labs.com/";
const TITLE = "Azerty Labs • Embedded AI in Eurorack (2020–2022)";
const OG_IMAGE = "https://azerty-labs.com/og-image.png";

const Homepage = () => {
    const currentSEO = SEO.find((item) => item.page === "home");

    return (
        <React.Fragment>
            <Helmet>
                <html lang="en" />
                <title>{TITLE}</title>
                <meta name="description" content={currentSEO.description} />
                <meta name="keywords" content={currentSEO.keywords.join(", ")} />
                <meta name="author" content="Chloé Lavrat" />
                <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
                <link rel="canonical" href={SITE_URL} />

                <meta property="og:type" content="website" />
                <meta property="og:site_name" content="Azerty Labs" />
                <meta property="og:locale" content="en_US" />
                <meta property="og:title" content={TITLE} />
                <meta property="og:description" content={currentSEO.description} />
                <meta property="og:url" content={SITE_URL} />
                <meta property="og:image" content={OG_IMAGE} />
                <meta property="og:image:width" content="1200" />
                <meta property="og:image:height" content="630" />
                <meta property="og:image:alt" content="Azerty Labs — Embedded AI in Eurorack. Brest, France. 2020–2022." />

                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content={TITLE} />
                <meta name="twitter:description" content={currentSEO.description} />
                <meta name="twitter:image" content={OG_IMAGE} />
                <meta name="twitter:image:alt" content="Azerty Labs — Embedded AI in Eurorack" />
            </Helmet>

            <div className="bg-lab-ink text-lab-paper font-sans min-h-screen antialiased">
                <HeroSection />
                <StorySection />
                <ProjectsSection />
                <PhilosophySection />
                <CTASection />
                <Footer />
            </div>
        </React.Fragment>
    );
};

export default Homepage;
